module.exports = __webpack_public_path__ + "static/media/a.afd4132d.jpg";